export default __webpack_public_path__ + "static/media/RegisterBg.8568707b.svg";